window.storeTime = "15";
window.storeNow = "2026-10-06T15:50:51";
window.storeHour = 15;

const CUT_OFF_HOUR = 22;
const ENABLE_TEST_DAYS = true; // <-- Set to false after testing

(function () {

  let dp = null;
  let originalFilter = null;

  function log(...args) {
    console.log("[Delivery Date]", ...args);
  }

  function showDeliveryDateUpdatedModal(oldDate, newDate) {
    $("#delivery-date-modal").remove();
    $("body").append(`
        <div id="delivery-date-modal" class="delivery-date-modal-overlay">
            <div class="delivery-date-modal">
                <div class="delivery-date-icon">📅</div>

                <h3>Delivery Date Updated</h3>

                <p>
                    The delivery date you selected
                    <strong>${oldDate}</strong>
                    is no longer available.
                </p>

                <p>
                    We've automatically selected the next available delivery date:
                </p>

                <div class="delivery-date-selected">
                    ${newDate}
                </div>

                <button type="button" id="delivery-date-modal-ok">
                    OK
                </button>
            </div>
        </div>
    `);

    $("#delivery-date-modal-ok").on("click", function () {
        $("#delivery-date-modal").fadeOut(200, function () {
            $(this).remove();
        });
    });
  }
  /**
   * Override Tuesday & Thursday for testing
   */

  function enableTestDays() {
      if (!ENABLE_TEST_DAYS) return;

      if (typeof originalFilter !== "function") return;

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      dp.options.filter = function(date, view) {
          // Keep original behavior for non-day views
          if (view !== "day") {
              return originalFilter.call(this, date, view);
          }
          const result = originalFilter.call(this, date, view);

          const checkDate = new Date(date);
          checkDate.setHours(0, 0, 0, 0);
          // Never enable today or any past date
          if (checkDate <= today) {
              return result;
          }
          const day = checkDate.getDay();

          // Only enable future Tuesdays & Thursdays
          if ((day === 2 || day === 4) && result === false) {
              return true;
          }
          return result;
      };
      refreshPicker();
  }

  function disableNextDayAfterCutoff() {
    // Only apply after cutoff
    if (Number(window.storeTime) < CUT_OFF_HOUR) {
        return;
    }

    if (typeof originalFilter !== "function") {
        return;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Disable tomorrow
    const nextDate = new Date(today);
    nextDate.setDate(nextDate.getDate() + 1);

    dp.options.filter = function (date, view) {
        // Keep original behaviour
        if (view !== "day") {
            return originalFilter.call(this, date, view);
        }
        const result = originalFilter.call(this, date, view);
        const checkDate = new Date(date);
        checkDate.setHours(0, 0, 0, 0);
        // Disable tomorrow
        if (checkDate.getTime() === nextDate.getTime()) {
            return false;
        }
        return result;
    };
    refreshPicker();
  }

  function getMinimumDeliveryDate() {
    let date = new Date(dp.options.startDate);

    if (Number(window.storeTime) >= CUT_OFF_HOUR) {
      date.setDate(date.getDate() + 1);
    }

    for (let i = 0; i < 60; i++) {
      let valid = true;
      if (typeof dp.options.filter === "function") {
        try {
          valid = dp.options.filter.call(dp, date, "day");
        } catch (e) {
          console.error(e);
        }
      }
      if (valid !== false) {
        return new Date(date);
      }
      date.setDate(date.getDate() + 1);
    }
    return new Date(dp.options.startDate);
  }

  function refreshPicker() {

    if (typeof dp.render === "function") {
      dp.render();
    }

    if (typeof dp.update === "function") {
      dp.update();
    }
  }

  function validateSelectedDate() {

    const value = $("#sbt_datepicker").val();

    if (!value) return;

    const parts = value.split("/");

    if (parts.length !== 3) return;

    const selected = new Date(
        parseInt(parts[2], 10),
        parseInt(parts[0], 10) - 1,
        parseInt(parts[1], 10)
    );

    selected.setHours(0, 0, 0, 0);

    // If current selection is allowed, nothing to do
    if (dp.options.filter(selected, "day") !== false) {
        return;
    }

    const nextDate = new Date(selected);
    // Search next available date (up to 60 days)
    for (let i = 0; i < 60; i++) {

        nextDate.setDate(nextDate.getDate() + 1);

        if (dp.options.filter(nextDate, "day") !== false) {

            const formatted =
                ("0" + (nextDate.getMonth() + 1)).slice(-2) + "/" +
                ("0" + nextDate.getDate()).slice(-2) + "/" +
                nextDate.getFullYear();

            // Update the datepicker
            if (typeof dp.setDate === "function") {
                dp.setDate(nextDate);
            }

            // Update the input
            originalVal.call($("#sbt_datepicker"), formatted);
            refreshPicker();
            showDeliveryDateUpdatedModal(value, formatted);
            return;
        }
    }
  }

  function protectDateInput() {
    const input = document.getElementById("sbt_datepicker");
    if (!input) return;
    // Ensure readonly initially
    input.setAttribute("readonly", "readonly");

    const observer = new MutationObserver(function (mutations) {

        for (const mutation of mutations) {

            if (
                mutation.type === "attributes" &&
                mutation.attributeName === "readonly"
            ) {
                if (!input.hasAttribute("readonly")) {
                  input.setAttribute("readonly", "readonly");
                }
            }
        }
    });

    observer.observe(input, {
        attributes: true,
        attributeFilter: ["readonly"]
    });
  }

  const observer = new MutationObserver(() => {

    const $field = $("#sbt_datepicker");

    if (!$field.length) return;

    const instance = $field.data("datepicker");

    if (!instance) return;

    observer.disconnect();

    dp = instance;
    originalFilter = dp.options.filter;

    protectDateInput();
    log("Datepicker Ready");

    // enableTestDays();
    disableNextDayAfterCutoff();

    const minimumDate = getMinimumDeliveryDate();

    if (typeof dp.update === "function") {

      dp.update({
        startDate: minimumDate
      });

    } else {

      dp.options.startDate = minimumDate;

    }

    refreshPicker();

    validateSelectedDate();

  });

  const originalVal = $.fn.val;

  $.fn.val = function () {

      const result = originalVal.apply(this, arguments);

      if (
          arguments.length &&
          this.length &&
          this[0].id === "sbt_datepicker"
      ) {
          setTimeout(validateSelectedDate, 0);
      }

      return result;
  };

  // $(document).on('input key', "#sbt_datepicker", function(e){
  //   console.log("sbt_datepicker Input");
  // });

  // $(document).on('change', "#sbt_datepicker", function(e){
  //   console.log("sbt_datepicker Change");
  // });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();